// frontend/src/api/shop.js
import axiosInstance from './axiosInstance';

const getRequestConfig = (payload) => (
  payload instanceof FormData
    ? { headers: { 'Content-Type': 'multipart/form-data' } }
    : undefined
);

export const shopAPI = {
  // Получить все категории
  getCategories: async () => {
    const response = await axiosInstance.get('/shop/categories/');
    return response.data;
  },

  // Создать категорию (админ)
  createCategory: async (payload) => {
    const response = await axiosInstance.post('/shop/categories/', payload);
    return response.data;
  },

  // Обновить категорию (админ)
  updateCategory: async (categoryId, payload) => {
    const response = await axiosInstance.patch(`/shop/categories/${categoryId}/`, payload);
    return response.data;
  },

  // Удалить категорию (админ)
  deleteCategory: async (categoryId) => {
    const response = await axiosInstance.delete(`/shop/categories/${categoryId}/`);
    return response.data;
  },

  // Получить все товары
  getProducts: async (params = {}) => {
    const queryParams = new URLSearchParams();

    if (params.category) queryParams.append('category', params.category);
    if (params.min_price) queryParams.append('min_price', params.min_price);
    if (params.max_price) queryParams.append('max_price', params.max_price);
    if (params.search) queryParams.append('search', params.search);
    if (params.sort) queryParams.append('sort', params.sort);

    const queryString = queryParams.toString();
    const url = queryString ? `/shop/products/?${queryString}` : '/shop/products/';

    const response = await axiosInstance.get(url);
    return response.data;
  },

  // Создать товар (админ)
  createProduct: async (payload) => {
    const response = await axiosInstance.post('/shop/products/', payload, getRequestConfig(payload));
    return response.data;
  },

  // Обновить товар (админ)
  updateProduct: async (productId, payload) => {
    const response = await axiosInstance.patch(`/shop/products/${productId}/`, payload, getRequestConfig(payload));
    return response.data;
  },

  // Удалить товар (админ)
  deleteProduct: async (productId) => {
    const response = await axiosInstance.delete(`/shop/products/${productId}/`);
    return response.data;
  },

  // Получить корзину
  getCart: async () => {
    const response = await axiosInstance.get('/shop/cart/');
    return response.data;
  },

  // Добавить товар в корзину
  addToCart: async (productId, quantity = 1) => {
    const cart = await shopAPI.getCart();
    const response = await axiosInstance.post(`/shop/cart/${cart.id}/add-item/`, {
      product_id: productId,
      quantity,
    });
    return response.data;
  },

  // Обновить количество товара в корзине
  updateCartItem: async (itemId, quantity) => {
    const cart = await shopAPI.getCart();
    const response = await axiosInstance.post(`/shop/cart/${cart.id}/update-item/`, {
      item_id: itemId,
      quantity,
    });
    return response.data;
  },

  // Удалить товар из корзины
  removeFromCart: async (itemId) => {
    const cart = await shopAPI.getCart();
    const response = await axiosInstance.post(`/shop/cart/${cart.id}/remove-item/`, {
      item_id: itemId,
    });
    return response.data;
  },

  // Очистить корзину
  clearCart: async () => {
    const cart = await shopAPI.getCart();
    const response = await axiosInstance.post(`/shop/cart/${cart.id}/clear/`);
    return response.data;
  },

  // Создать заказ
  createOrder: async (orderData) => {
    const response = await axiosInstance.post('/shop/orders/', {
      ...orderData,
      notes: orderData.notes || '',
      delivery_method: orderData.delivery_method || 'coach',
      payment_agreed: orderData.payment_agreed || false,
      data_processing_agreed: orderData.data_processing_agreed || false,
      coach_agreement_agreed: orderData.coach_agreement_agreed || false,
    });
    return response.data;
  },

  // Получить заказы
  // По умолчанию: только текущего пользователя.
  // adminAll=true: все заказы (только для админов).
  getOrders: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.adminAll) queryParams.append('admin_all', 'true');
    if (params.includeClosed) queryParams.append('include_closed', 'true');
    if (params.statusGroup) queryParams.append('status_group', params.statusGroup);

    const queryString = queryParams.toString();
    const url = queryString ? '/shop/orders/?' + queryString : '/shop/orders/';

    const response = await axiosInstance.get(url);
    return response.data;
  },


  // Обновить статус/данные заказа (админ)
  updateOrder: async (orderId, payload) => {
    const response = await axiosInstance.patch(`/shop/orders/${orderId}/`, payload);
    return response.data;
  },
  // Получить заказ по ID
  getOrder: async (orderId) => {
    const response = await axiosInstance.get(`/shop/orders/${orderId}/`);
    return response.data;
  },

  repeatOrder: async (orderId) => {
    const response = await axiosInstance.post(`/shop/orders/${orderId}/repeat/`);
    return response.data;
  },
};
